import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { toast } from "sonner";
import adminApi from "../lib/adminApi";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export function AdminProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("ha_admin_token") || "");
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ha_admin_user") || "null"); } catch { return null; }
  });

  const isAuthed = !!token && !!user?.is_admin;

  useEffect(() => {
    const onSignout = () => {
      localStorage.removeItem("ha_admin_token");
      localStorage.removeItem("ha_admin_user");
      setToken("");
      setUser(null);
      const lang = localStorage.getItem("ha_lang") || "sv";
      toast.error(lang === "ar" ? "انتهت الجلسة، الرجاء تسجيل الدخول من جديد" : "Sessionen har gått ut. Logga in igen.");
    };
    window.addEventListener("ha-admin-signout", onSignout);
    return () => window.removeEventListener("ha-admin-signout", onSignout);
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await adminApi.login(email, password);
    if (!data?.user?.is_admin) {
      const err = new Error("not_admin");
      err.code = "not_admin";
      throw err;
    }
    localStorage.setItem("ha_admin_token", data.token);
    localStorage.setItem("ha_admin_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const loginWithSession = useCallback(async (sessionId) => {
    const data = await adminApi.session(sessionId);
    if (!data?.user?.is_admin) {
      const err = new Error("not_admin");
      err.code = "not_admin";
      err.email = data?.user?.email;
      throw err;
    }
    localStorage.setItem("ha_admin_token", data.token);
    localStorage.setItem("ha_admin_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ha_admin_token");
    localStorage.removeItem("ha_admin_user");
    setToken("");
    setUser(null);
  }, []);

  return (
    <AdminContext.Provider value={{ token, user, isAuthed, login, loginWithSession, logout }}>
      {children}
    </AdminContext.Provider>
  );
}
